import { inject, Injectable } from '@angular/core';
import { FieldDef } from 'app/core/models';
import { FilterListItemModel } from 'tsui';
import { FieldDefsState } from 'app/state/fields/state';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root',
})
export class TsFilterUtilsService {
  protected readonly store = inject(Store);

  getFilterList(fieldDefs: FieldDef[]): FilterListItemModel[] {
    return fieldDefs.map(({ label, name, type, meta, _parentFieldLabel, _parentFieldMeta, _parentFieldName }) => {
      const fieldOptions = this.formatFieldOptions(meta);

      return {
        label,
        name,
        meta: {
          filtering: { operators: meta?.filtering?.operators || [], functions: meta?.filtering?.functions || [] },
          options: fieldOptions,
          multi_select: meta?.multi_select || false,
          record_type: meta?.record_type || null,
          group: meta?.group,
          scale: meta?.scale,
        },
        type,
        _parentFieldLabel,
        _parentFieldMeta,
        _parentFieldName,
      } as FilterListItemModel;
    });
  }

  private formatFieldOptions(meta: any): string[] | { label: string; value: string }[] {
    const dropdownOptions = this.store.selectSnapshot(FieldDefsState.selectDropdownOptionsBy(meta?.option_name));

    if (dropdownOptions) {
      return dropdownOptions.map((option) => ({ label: option.name, value: option.id }));
    }

    return meta?.options || [];
  }
}
